import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/research/page.tsx");
